import React, { Component, useState, useEffect } from "react";
import Slider from "../../widgets/NetflixSlider";
import VideoYouTube from "../../components/Youtube/Youtube.jsx";
import { ExamEvaluative } from "../../components/Exam/ExamEvaluative.jsx";

import { HttpLink } from "apollo-link-http";
import { ApolloClient } from "apollo-client";
import { Exam } from "../../components/Exam/Exam.jsx";
import { InMemoryCache } from "apollo-cache-inmemory";
import { isMobile } from "react-device-detect";
import gql from "graphql-tag";
import { Query } from "react-apollo";

import { Scorm } from "../../components/Course/Scorm.jsx";

const restLink_lms = new HttpLink({
  uri: "/api/v1/lms/",
  credentials: "include",
});
const lms_client = new ApolloClient({
  link: restLink_lms,
  cache: new InMemoryCache(),
});

const restLink_dam = new HttpLink({
  uri: "/api/v1/dam/",
  credentials: "include",
});
const dam_client = new ApolloClient({
  link: restLink_dam,
  cache: new InMemoryCache(),
});

const restLink_account = new HttpLink({
  uri: "/api/v1/account/",
  credentials: "include",
});
const account_client = new ApolloClient({
  link: restLink_account,
  cache: new InMemoryCache(),
});
const _GET_TRAILITEMS = gql`
  query trailhascourse($trail_id: Int!) {
    trailhascourse(trail_id: $trail_id) {
      trailhascourses {
        id
        course {
          id
          title
          description
          thumbnail
          scorm
          active
          video {
            id
            uuid
          }
        }
      }
    }
  }
`;

// const _GET_TRAILITEMS = gql`query getCourse($id: Int!) {
//   course(id:$id){
//     id,
//     title,
//     description,
//     scorm,
//     hours,
//     minutes,
//     thumbnail,
//     code,
//     video{
//       id, thumbnail
//     },
//     proof{
//       id, title
//     },
//     reactionevaluation{
//       id, title
//     }
//   }
// }
// `}

const GET_COURSE = gql`
  query course($id: Int!) {
    course(id: $id) {
      id
      title
      description
      scorm
      hours
      minutes
      thumbnail
      code
      video {
        id
        thumbnail
        uuid
      }
      proof {
        id
        title
      }
      reactionevaluation {
        id
        title
      }
    }
  }
`;

const VIDEO_HAS_USER = gql`
  mutation createOrUpdateVideoHasUser(
    $video_id: String!
    $time: Int!
    $time_reproduced: Int!
    $time_seconds: String!
  ) {
    createOrUpdateVideoHasUser(
      input: {
        video_id: $video_id
        time: $time
        time_reproduced: $time_reproduced
        time_seconds: $time_seconds
      }
    ) {
      id
    }
  }
`;

const TRAIL_ITEM_HAS_USER = gql`
  mutation trailItemHasUser(
    $trail_id: Int!
    $item_id: Int!
    $item_type: String!
  ) {
    createTrailItemHasUser(
      input: { trail_id: $trail_id, item_id: $item_id, item_type: $item_type }
    ) {
      id
    }
  }
`;

const GET_TRAIL_ITEM_HAS_USER = gql`
  query getTrailItemHasUser($trail_id: Int!) {
    trail_itens_by_user(trail_id: $trail_id) {
      trailitenshasuser {
        item_id
        item_type
      }
    }
  }
`;

const GET_ASSET = gql`
  query asset($id: Int!) {
    asset(id: $id) {
      id
      title
      asset
      thumbnail
    }
  }
`;

const GET_TRAILITEMS = gql`
  query trailitems($trail_id: Int!) {
    trailitems(trail_id: $trail_id) {
      trailitems {
        id
        item_id
        item_type
        ordernum
      }
    }
  }
`;

const GET_PROOF = gql`
  query getProof($proof_id: Int!) {
    proof(id: $proof_id) {
      questions {
        id
        title
        answers {
          id
          title
        }
      }
    }
  }
`;

const GET_TRAIL_PROOF = gql`
  query getTrail($trail_id: Int!) {
    trail(id: $trail_id) {
      proof {
        id
        title
      }
    }
  }
`;

const GET_ANSWER_QUESTION = gql`
  query answer_question_collections(
    $proof_id: Int!
    $item_id: Int!
    $item_type: String!
  ) {
    answer_question_collections(
      proof_id: $proof_id
      item_id: $item_id
      item_type: $item_type
    ) {
      answers_question {
        id
      }
    }
  }
`;

const GET_TRAIL_REACTIONEVALUATION = gql`
  query getTrail($trail_id: Int!) {
    trail(id: $trail_id) {
      reactionevaluation {
        id
        title
      }
    }
  }
`;

const GET_TRAIL_HAS_USER_ITEM = gql`
  query trail_has_user_item($trail_id: Int!) {
    trail_has_user_item(trail_id: $trail_id) {
      user_id
      status
    }
  }
`;

const GET_SETTINGS = gql`
  query get_settings {
    get_settings {
      id
      youtube_channel_id
      youtube_playlist_id
      youtube_playlist_title
      client_id
      client_secret
      token
      folder_id
      video_platform
    }
  }
`;

const GET_USER = gql`
  query get_authenticated_user {
    get_authenticated_user {
      id
      name
      mail
      uid
      is_confirm
    }
  }
`;

const FINISH_TRAIL = gql`
  mutation updateTrailHasUser($trail_id: Int!, $status: String!) {
    updateTrailHasUser(input: { trail_id: $trail_id, status: $status }) {
      id
    }
  }
`;

var intervalGetCurlTime = null;

var viewedAssets = []; // Array criado para permitir a conclusão do Assets sem a necessidade de baixar

export default function CoursePage(props) {
  var player = false;
  var isPlay = false;

  var intervalGetCurTime = false;
  var lastAmountOfTimesSend = 0;
  var lastCurTime = 0;
  var curTime = 0;
  var time = 0;
  var arrSeconds = [];
  var timeAll = 0;
  var percVideo = [];
  var jsonObj = [];

  var completedCourseTrigger = [];

  const [trailItens, setTrailItens] = useState([]);

  const [thisTrail, setThisTrail] = useState([]);

  const [trailReactionevaluation, setTrailReactionevaluation] = useState([]);

  const [isEnter, setIsEnter] = useState(false);

  const [trailItemActive, setTrailItemActive] = useState(0);

  // const [player, setPlayer] = useState([]);

  const [itemActive, setItemActive] = useState(0);

  const [user, setUser] = useState(0);
  // const [active, setActive] = useState(0);
  const [completedCourse, setCompletedCourse] = useState([]);
  const [settingsPlatform, setSettingsPlatform] = useState([]);
  // const [aulas, setAulas] = useState([]);
  // const [perc, setPerc] = useState(false);

  const [trailHasUser, setTrailHasUser] = useState(false);
  const [trailFinish, setTrailFinish] = useState(false);

  const activeCourse = (trailItemActive, itemActive) => {
    if (intervalGetCurlTime !== null) {
      clearInterval(intervalGetCurlTime);
    }
    setTrailItemActive(trailItemActive);
    setItemActive(itemActive);
  };

  function setCompletedItem(arrSeconds) {
    lms_client.mutate({
      mutation: VIDEO_HAS_USER,
      variables: {
        video_id: itemActive.video.uuid,
        time: timeAll,
        time_reproduced: arrSeconds.length,
        time_seconds: JSON.stringify(arrSeconds),
      },
    });
  }

  function setCompletedTrail() {
    completedCourse[trailItemActive.ordernum] = true;
    setCompletedCourse(completedCourse);

    let a = 0;
    let b = 0;

    completedCourse.forEach(function(
      completedCourseItem,
      completedCourseIndex
    ) {
      b++;
    });

    var hasProof = false;

    trailItens.forEach(function(trailItem, completedCourseIndex) {
      // Se tem avaliação na trilha
      if (trailItem.item_type === "Proof") {
        hasProof = true;
      }
      if (
        trailItem.item_type !== "Proof" &&
        trailItem.item_type !== "Reactionevaluation" &&
        trailItem.item_type !== "Certificate"
      ) {
        a++;
      }
    });

    //console.log("---------------- hasProof ----------------------");
    //console.log(hasProof);

    if (!hasProof && a === b) {
      lms_client.mutate({
        variables: {
          trail_id: props.match.params.trail_id,
          status: "finalized",
        },
        mutation: FINISH_TRAIL,
      });
    }
    handleUpdate();
  }

  var setCommitScorm = () => {
    lms_client.mutate({
      variables: {
        trail_id: props.match.params.trail_id,
        item_id: trailItemActive.item_id,
        item_type: "course",
      },
      mutation: TRAIL_ITEM_HAS_USER,
    });
    setCompletedTrail();
  };

  var setFinishScorm = () => {
    lms_client.mutate({
      variables: {
        trail_id: props.match.params.trail_id,
        item_id: trailItemActive.item_id,
        item_type: "course",
      },
      mutation: TRAIL_ITEM_HAS_USER,
    });
    completedCourse[trailItemActive.ordernum] = true;
    setCompletedCourse(completedCourse);
    handleUpdate();
  };

  var setInitializeScorm = () => {
    // completedCourse[trailItemActive.ordernum] = true;
    // setCompletedCourse(completedCourse);
    // handleUpdate();
  };

  async function init() {
    var trailItens = (
      await lms_client.query({
        variables: { trail_id: props.match.params.trail_id },
        query: GET_TRAILITEMS,
      })
    ).data.trailitems.trailitems;

    lms_client.mutate({
      variables: { trail_id: props.match.params.trail_id, status: "started" },
      mutation: FINISH_TRAIL,
    });

    var thisTrail = (
      await lms_client.query({
        variables: { trail_id: props.match.params.trail_id },
        query: GET_TRAIL_PROOF,
      })
    ).data.trail;

    //console.log(thisTrail);

    var trailReactionevaluation = (
      await lms_client.query({
        variables: { trail_id: props.match.params.trail_id },
        query: GET_TRAIL_REACTIONEVALUATION,
      })
    ).data.trail;

    var trailReactionevaluation = (
      await lms_client.query({
        variables: { trail_id: props.match.params.trail_id },
        query: GET_TRAIL_REACTIONEVALUATION,
      })
    ).data.trail;

    var settings = (
      await lms_client.query({
        query: GET_SETTINGS,
      })
    ).data;

    var userQuery = (
      await account_client.query({
        variables: { trail_id: props.match.params.trail_id },
        query: GET_USER,
      })
    ).data.get_authenticated_user;

    // console.log(user);

    setUser(userQuery);

    setSettingsPlatform(settings.get_settings.video_platform);

    // var proofTrail = (await lms_client.query({
    //   variables: { proof_id: 2 },
    //   query: GET_PROOF
    // })).data.proof.questions;

    var trailFinish = (
      await lms_client.query({
        variables: { trail_id: props.match.params.trail_id },
        query: GET_TRAIL_HAS_USER_ITEM,
      })
    ).data.trail_has_user_item;

    if (thisTrail.proof !== null && thisTrail.proof !== undefined) {
      // console.log(trailItens.length);
      if (trailItens.length > 3) {
        if (
          trailItens[trailItens.length - 1].__typename !== "Proof" &&
          trailItens[trailItens.length - 2].__typename !== "Proof" &&
          trailItens[trailItens.length - 3].__typename !== "Proof"
        ) {
          trailItens.push({
            id: thisTrail.proof.id,
            item_id: thisTrail.proof.id,
            item_type: "Proof",
            ordernum: trailItens.length + 1,
            __typename: "Proof",
          });
        }
      } else {
        trailItens.push({
          id: thisTrail.proof.id,
          item_id: thisTrail.proof.id,
          item_type: "Proof",
          ordernum: trailItens.length + 1,
          __typename: "Proof",
        });
      }
    }

    if (trailFinish !== null && trailFinish !== undefined) {
      if (trailFinish.status === "finalized") {
        if (trailItens[trailItens.length - 1].__typename === "Proof") {
          completedCourseTrigger[trailItens.length] = true;
          setCompletedCourse(completedCourseTrigger);
        } else {
          completedCourseTrigger[trailItens.length - 2] = true;
          setCompletedCourse(completedCourseTrigger);
        }
      }
    }

    if (
      trailReactionevaluation.reactionevaluation !== null &&
      trailReactionevaluation.reactionevaluation !== undefined
    ) {
      if (trailItens.length > 3) {
        if (
          trailItens[trailItens.length - 1].__typename !==
            "Reactionevaluation" &&
          trailItens[trailItens.length - 2].__typename !==
            "Reactionevaluation" &&
          trailItens[trailItens.length - 3].__typename !== "Reactionevaluation"
        ) {
          trailItens.push({
            id: trailReactionevaluation.reactionevaluation.id,
            item_id: trailReactionevaluation.reactionevaluation.id,
            item_type: "Reactionevaluation",
            ordernum: trailItens.length + 1,
            __typename: "Reactionevaluation",
          });
        }
      } else {
        trailItens.push({
          id: trailReactionevaluation.reactionevaluation.id,
          item_id: trailReactionevaluation.reactionevaluation.id,
          item_type: "Reactionevaluation",
          ordernum: trailItens.length + 1,
          __typename: "Reactionevaluation",
        });
      }
    }

    if (thisTrail.proof !== null && thisTrail.proof !== undefined) {
      if (trailItens.length > 3) {
        if (
          trailItens[trailItens.length - 1].__typename !== "Certificate" &&
          trailItens[trailItens.length - 2].__typename !== "Certificate" &&
          trailItens[trailItens.length - 3].__typename !== "Certificate"
        ) {
          trailItens.push({
            id: 100,
            item_id: 100,
            item_type: "Certificate",
            title: "Certificado",
            ordernum: trailItens.length + 1,
            __typename: "Certificate",
          });
        }
      } else {
        trailItens.push({
          id: 100,
          item_id: 100,
          item_type: "Certificate",
          title: "Certificado",
          ordernum: trailItens.length + 1,
          __typename: "Certificate",
        });
      }
    }

    var answerQuestionTrail = (
      await lms_client.query({
        variables: {
          proof_id: trailItens[trailItens.length - 1].id,
          item_id: trailItens[trailItens.length - 1].item_id,
          item_type: "trail",
        },
        query: GET_ANSWER_QUESTION,
      })
    ).data.answer_question_collections;

    if (answerQuestionTrail && answerQuestionTrail.answers_question.length) {
      completedCourseTrigger[trailItens.length] = true;
      setCompletedCourse(completedCourseTrigger);
    }

    var trailItensCompleted = (
      await lms_client.query({
        variables: { trail_id: props.match.params.trail_id },
        query: GET_TRAIL_ITEM_HAS_USER,
        fetchPolicy: "no-cache",
      })
    ).data.trail_itens_by_user.trailitenshasuser;

    trailItensCompleted.forEach(function(
      trailItemCompleted,
      trailItemCompletedIndex
    ) {
      trailItens.forEach(function(trailItem, trailItemIndex) {
        if (
          trailItemCompleted.item_id === trailItem.item_id &&
          trailItemCompleted.item_type === trailItem.item_type
        ) {
          completedCourseTrigger[trailItem.ordernum] = true;
          setCompletedCourse(completedCourseTrigger);
        }
      });
    });

    // Seta todos os itens da trilha
    setTrailItens(trailItens);

    setTrailReactionevaluation(trailReactionevaluation.reactionevaluation);

    setThisTrail(thisTrail.proof);

    // Seta o primeiro item da trilha como ativado, depois verifica se ele curso ou asset para pegar o conteudo e setar como ativado

    var trailItem = undefined;

    if (typeof props.match.params.course_id !== "undefined") {
      trailItens.forEach(function(trailItemLoop, trailItemIndex) {
        if (trailItemLoop.item_id === parseInt(props.match.params.course_id)) {
          trailItem = trailItemLoop;
        }
      });
    }

    if (typeof trailItem === "undefined") {
      trailItem = trailItens[0];
    }

    if (!isMobile) {
      if (trailItem.item_type == "course") {
        var itemCourse = (
          await lms_client.query({
            variables: { id: trailItem.item_id },
            query: GET_COURSE,
          })
        ).data.course;
        activeCourse(trailItem, itemCourse);
      } else if (trailItem.item_type == "asset") {
        await dam_client
          .query({
            variables: { id: trailItem.item_id },
            query: GET_ASSET,
          })
          .then((result) => {
            activeCourse(trailItem, result.data.asset);
          });
      }
    }
  }

  function uniqArrayValues(a) {
    var seen = {};
    var out = [];
    var len = a.length;
    var j = 0;
    for (var i = 0; i < len; i++) {
      var item = a[i];
      if (seen[item] !== 1) {
        seen[item] = 1;
        out[j++] = item;
      }
    }
    return out;
  }

  useEffect(() => {
    init();
  }, []);

  async function getCurTime(player) {
    if (!player) {
      return null;
    }

    try {
      if (trailItemActive) {
        if (settingsPlatform === "youtube") {
          time = parseInt(player.getCurrentTime());
          timeAll = parseInt(player.getDuration());
          curTime = player.getCurrentTime();
        } else {
          time = parseInt(await player.getCurrentTime());
          timeAll = parseInt(await player.getDuration());
          curTime = await player.getCurrentTime();
        }

        if (time !== 0) {
          arrSeconds.push(time);
          arrSeconds = uniqArrayValues(arrSeconds);

          //console.log("--------------- pushTime ");
          //console.log(arrSeconds);
          if (arrSeconds.length > lastAmountOfTimesSend + 10) {
            //console.log("--------------- Registrou ---------------------------------- ");
            lastAmountOfTimesSend = arrSeconds.length;
            setCompletedItem(arrSeconds);
          }

          if (completedCourseTrigger[trailItemActive.ordernum] !== true) {
            if (parseInt((arrSeconds.length / timeAll) * 100) >= 70) {
              // 70%

              completedCourseTrigger = completedCourse;
              completedCourseTrigger[trailItemActive.ordernum] = true;
              setCompletedCourse(completedCourseTrigger);
              // lmsCompletedCourse(completedCourseTrigger);
              handleUpdate();
              setCompletedItem(arrSeconds);
              setCompletedTrail();
              // Salva o item do course quando chegar em 70%
              lms_client.mutate({
                variables: {
                  trail_id: props.match.params.trail_id,
                  item_id: trailItemActive.item_id,
                  item_type: "course",
                },
                mutation: TRAIL_ITEM_HAS_USER,
              });
            }
          }
        }
      }
      //console.log(curTime);
      if (isPlay && (curTime === 0 || lastCurTime !== curTime)) {
        lastCurTime = curTime;
        setTimeout(() => getCurTime(player), 300);
      }
    } catch (e) {
      //console.log("=============== CATCH ===================");
      // handler(false);
    }
  }

  function setCourseFinish() {
    // console.log("============ setTrailFinish(true) ===========");
    setTrailFinish(true);

    if (completedCourseTrigger[trailItemActive.ordernum] !== true) {
      completedCourseTrigger = completedCourse;
      completedCourseTrigger[trailItemActive.ordernum] = true;
      setCompletedCourse(completedCourseTrigger);
    }
    handleUpdate();
  }

  let [, setState] = useState();

  function handleUpdate() {
    setState({});
  }

  async function onPlay(event) {
    isPlay = true;

    //console.log("============== onPlay ===============");
    //console.log(player);

    if (typeof player !== "undefined" && player) {
      //console.log("setTimeout ------------------");
      setTimeout(() => getCurTime(player), 300);
      //intervalGetCurTime = setInterval(() => getCurTime(player), 300);
    }
  }

  async function onPause(event) {
    isPlay = false;
    //if(intervalGetCurTime) {
    //  clearInterval(intervalGetCurTime);
    //}
    // console.log("onPause");
  }

  async function onError(event) {
    isPlay = false;
    //if(intervalGetCurTime) {
    //  clearInterval(intervalGetCurTime);
    //}
    //console.log("onError");
  }

  async function onEnd(event) {
    isPlay = false;
    //if(intervalGetCurTime) {
    //  clearInterval(intervalGetCurTime);
    //}
    //console.log("onEnd");

    if (typeof arrSeconds !== "undefined" && arrSeconds.length) {
      if (completedCourseTrigger[trailItemActive.ordernum] !== true) {
        completedCourseTrigger = completedCourse;
        completedCourseTrigger[trailItemActive.ordernum] = true;
        setCompletedCourse(completedCourseTrigger);
        // lmsCompletedCourse(completedCourseTrigger);
        handleUpdate();
        setCompletedItem(arrSeconds);
        setCompletedTrail();
        // Salva o item do course quando chegar em 70%
        lms_client.mutate({
          variables: {
            trail_id: props.match.params.trail_id,
            item_id: trailItemActive.item_id,
            item_type: "course",
          },
          mutation: TRAIL_ITEM_HAS_USER,
        });
      }
    }
  }

  async function onReady(event) {
    if (intervalGetCurTime) {
      clearInterval(intervalGetCurTime);
    }

    // console.log(event.target);
    if (settingsPlatform === "youtube") {
      // player = event.target;

      player = event.target;
    } else {
      //console.log("---------- Component/LmsPage > onReady ---------------");
      //console.log(event);
      player = event;
    }
  }

  // Definir assets como concluído apenas com a ação de abrir
  if (
    trailItemActive &&
    trailItemActive.item_type === "asset" &&
    !viewedAssets.includes(trailItemActive.id)
  ) {
    //console.log("-------------------------- Definindo item como concluído");
    //console.log(viewedAssets.includes(trailItemActive.id));
    viewedAssets.push(trailItemActive.id);
    //console.log(viewedAssets);
    //console.log(viewedAssets.includes(trailItemActive.id));
    setCompletedTrail();
    lms_client.mutate({
      variables: {
        trail_id: props.match.params.trail_id,
        item_id: trailItemActive.item_id,
        item_type: "asset",
      },
      mutation: TRAIL_ITEM_HAS_USER,
    });
  }

  return (
    <div className="course-page sliderlms">
      <div className="app">
        <Slider>
          {trailItens.map((trailItem, index) => (
            <div key={index}>
              {trailItem.item_type === "course" && (
                <Query
                  client={lms_client}
                  query={GET_COURSE}
                  variables={{ id: trailItem.item_id }}
                >
                  {({ loading, error, data }) => {
                    if (loading) return <div>Carregando...</div>;
                    if (error) return <div>Erro :(</div>;

                    if (!data.course) {
                      return <div></div>;
                    }

                    var unlock = false;

                    if (
                      trailItem.ordernum === 1 ||
                      typeof completedCourse[trailItem.ordernum] !==
                        "undefined" ||
                      typeof completedCourse[trailItem.ordernum - 1] !==
                        "undefined"
                    ) {
                      unlock = true;
                    }

                    return (
                      <div>
                        <button
                          disabled={!unlock}
                          key={completedCourse}
                          className="btn-course"
                          onClick={() => {
                            activeCourse(trailItem, data.course);
                            if (isMobile) {
                              setIsEnter(true);
                            }
                          }}
                        >
                          <Slider.Item
                            unlock={unlock}
                            completedCourse={
                              completedCourse[trailItem.ordernum]
                            }
                            movie={data.course}
                            active={itemActive}
                            key={data.course}
                          ></Slider.Item>
                        </button>
                      </div>
                    );
                  }}
                </Query>
              )}

              {trailItem.item_type === "asset" && (
                <Query
                  client={dam_client}
                  query={GET_ASSET}
                  variables={{ id: trailItem.item_id }}
                >
                  {({ loading, error, data }) => {
                    if (loading) return <div>Carregando...</div>;
                    if (error) return <div>Erro :(</div>;

                    if (!data.asset) {
                      return <div></div>;
                    }
                    var unlock = false;

                    if (
                      trailItem.ordernum === 1 ||
                      typeof completedCourse[trailItem.ordernum] !==
                        "undefined" ||
                      typeof completedCourse[trailItem.ordernum - 1] !==
                        "undefined"
                    ) {
                      unlock = true;
                    }
                    return (
                      <div>
                        <button
                          disabled={!unlock}
                          key={completedCourse}
                          className="btn-course"
                          onClick={() => activeCourse(trailItem, data.asset)}
                        >
                          <Slider.Item
                            unlock={unlock}
                            completedCourse={
                              completedCourse[trailItem.ordernum]
                            }
                            movie={data.asset}
                            active={itemActive}
                            key={data.asset.id}
                          ></Slider.Item>
                        </button>
                      </div>
                    );
                  }}
                </Query>
              )}
              {trailItem.item_type === "Proof" && (
                <Query
                  client={lms_client}
                  query={GET_TRAIL_PROOF}
                  variables={{ trail_id: props.match.params.trail_id }}
                >
                  {({ loading, error, data }) => {
                    if (loading) return <div>Carregando...</div>;
                    if (error) return <div>Erro :(</div>;

                    if (!data.trail) {
                      return <div></div>;
                    }

                    var unlock = false;

                    if (
                      trailItem.ordernum === 1 ||
                      typeof completedCourse[trailItem.ordernum] !==
                        "undefined" ||
                      typeof completedCourse[trailItem.ordernum - 1] !==
                        "undefined"
                    ) {
                      unlock = true;
                    }
                    return (
                      <div>
                        <button
                          disabled={!unlock}
                          key={completedCourse}
                          className="btn-course"
                          onClick={() =>
                            activeCourse(trailItem, data.trail.proof)
                          }
                        >
                          <Slider.Item
                            unlock={unlock}
                            completedCourse={
                              completedCourse[trailItem.ordernum]
                            }
                            movie={data.trail.proof}
                            active={itemActive}
                            key={data.trail.proof}
                          ></Slider.Item>
                        </button>
                      </div>
                    );
                  }}
                </Query>
              )}
              {trailItem.item_type === "Certificate" && (
                <Query
                  client={lms_client}
                  query={GET_TRAIL_PROOF}
                  variables={{ trail_id: props.match.params.trail_id }}
                >
                  {({ loading, error, data }) => {
                    var unlock = false;

                    if (
                      trailItens[trailItens.length - 2].item_type ===
                      "Reactionevaluation"
                    ) {
                      if (
                        trailItem.ordernum === 1 ||
                        typeof completedCourse[trailItem.ordernum] !==
                          "undefined" ||
                        typeof completedCourse[trailItem.ordernum - 2] !==
                          "undefined"
                      ) {
                        unlock = true;
                      }
                    } else {
                      if (
                        trailItem.ordernum === 1 ||
                        typeof completedCourse[trailItem.ordernum] !==
                          "undefined" ||
                        typeof completedCourse[trailItem.ordernum - 1] !==
                          "undefined"
                      ) {
                        unlock = true;
                      }
                    }

                    return (
                      <div>
                        <button
                          disabled={!unlock}
                          key={completedCourse}
                          className="btn-course"
                          onClick={() => activeCourse(trailItem, trailItem)}
                        >
                          <Slider.Item
                            unlock={unlock}
                            completedCourse={
                              completedCourse[trailItem.ordernum]
                            }
                            movie={trailItem}
                            active={itemActive}
                            key={trailItem}
                          ></Slider.Item>
                        </button>
                      </div>
                    );
                  }}
                </Query>
              )}
              {trailItem.item_type === "Reactionevaluation" && (
                <Query
                  client={lms_client}
                  query={GET_TRAIL_REACTIONEVALUATION}
                  variables={{ trail_id: 2 }}
                >
                  {({ loading, error, data }) => {
                    if (loading) return <div>Carregando...</div>;
                    if (error) return <div>Erro :(</div>;

                    if (!data.trail) {
                      return <div></div>;
                    }

                    var unlock = false;

                    if (
                      trailItem.ordernum === 1 ||
                      typeof completedCourse[trailItem.ordernum] !==
                        "undefined" ||
                      typeof completedCourse[trailItem.ordernum - 1] !==
                        "undefined"
                    ) {
                      unlock = true;
                    }

                    return (
                      <div>
                        <button
                          disabled={!unlock}
                          key={completedCourse}
                          className="btn-course"
                          onClick={() =>
                            activeCourse(
                              trailItem,
                              data.trail.reactionevaluation
                            )
                          }
                        >
                          <Slider.Item
                            unlock={unlock}
                            completedCourse={
                              completedCourse[trailItem.ordernum]
                            }
                            movie={data.trail.reactionevaluation}
                            active={itemActive}
                            key={data.trail.reactionevaluation}
                          ></Slider.Item>
                        </button>
                      </div>
                    );
                  }}
                </Query>
              )}
            </div>
          ))}
        </Slider>
        {props.match.params.trail_id == 5 && completedCourse.length > 0 && (
          <a
            href="/#/home/1"
            className="btn btn-fill btn-success btn-full"
            onClick={() => true}
          >
            Próximo conteúdo
          </a>
        )}
      </div>
      <div className="course-content">
        {/*<h1>{itemActive.title}</h1>*/}
        {trailItemActive.item_type === "course" && itemActive.video && (
          <VideoYouTube
            settings={settingsPlatform}
            key={itemActive.id}
            onPlay={onPlay}
            onEnd={onEnd}
            onPause={onPause}
            onReady={onReady}
            onError={onError}
            videoId={itemActive.video.uuid}
          />
        )}
        {trailItemActive.item_type === "course" && itemActive.scorm && (
          <React.Fragment>
            <Scorm
              setCommitScorm={setCommitScorm}
              isEnter={isEnter}
              setIsEnter={setIsEnter}
              setFinishScorm={setFinishScorm}
              setInitializeScorm={setCommitScorm}
              user={user}
              course={itemActive}
            />
          </React.Fragment>
        )}
        {trailItemActive.item_type === "asset" && (
          <div>
            <img
              src={"/dam/assets/" + (itemActive.thumbnail !== null && itemActive.thumbnail !== "" ? itemActive.thumbnail : itemActive.asset)}
              className="full-width"
            />
            <a
              className="btn btn-info btn-fill btn-full btn-content"
              target="_blank"
              download
              href={"/dam/assets/" + itemActive.asset}
              onClick={() => {
                // onClick trocado por onLoad
                // completedCourse[trailItemActive.ordernum] = true;
                // setCompletedCourse(completedCourse);
                setCompletedTrail();
                lms_client.mutate({
                  variables: {
                    trail_id: props.match.params.trail_id,
                    item_id: trailItemActive.item_id,
                    item_type: "asset",
                  },
                  mutation: TRAIL_ITEM_HAS_USER,
                });
                handleUpdate();
              }}
            >
              Clique para baixar arquivo
            </a>
          </div>
        )}

        {trailItemActive.item_type === "Certificate" && (
          <div>
            <h2 className="title">Certificado</h2>
            <a
              className="btn btn-fill btn-primary full-width"
              download
              href={
                "api/v1/lms/certified_trail_generat?u=" +
                props.match.params.trail_id
              }
              onClick={() => {}}
            >
              Download do certificado
            </a>
          </div>
        )}
        {trailItemActive.item_type === "Reactionevaluation" && (
          <div>
            <ExamEvaluative
              setCourseFinish={setCourseFinish}
              item_id={props.match.params.trail_id}
              item_type="trail"
              proof_id={trailItemActive.id}
            />
          </div>
        )}
        {trailItemActive.item_type === "Proof" && (
          <div>
            <Exam
              setCourseFinish={setCourseFinish}
              trail_id={props.match.params.trail_id}
              item_id={props.match.params.trail_id}
              item_type="trail"
              proof_id={trailItemActive.id}
            />
          </div>
        )}
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/views/CoursePage/CoursePage.jsx